import SelfSchedule from '@/pages/SelfSchedule';
import { ROUTES } from './routes.config'; 

export const SelfSchedulePageRoutes = {
    path: ROUTES.SELF_SCHEDULE,
    element: <SelfSchedule />,
};